import type { STChecklistItem } from '@st/sdk'
import { Button, Dialog, DialogButtons } from '@st/theme'
import { match } from '@st/pattern'
type Props = { checklistItem: STChecklistItem; onClose: () => void }
export function ManageChecklistItemCompletion({ checklistItem, onClose }: Props) {
  return (
    <Dialog
      title={match(checklistItem.status)
        .with('complete', () => 'Item completed')
        .with('incomplete', () => 'Mark as completed')
        .exhaustive()}
      className="w-96"
      buttons={
        <DialogButtons>
          <Button variant="primary" onClick={onClose}>
            OK
          </Button>
        </DialogButtons>
      }
    >
      {match(checklistItem)
        .with({ status: 'complete' }, () => {
          return (
            <div className="flex flex-col gap-2">
              This checklist item has been marked completed because the relevant information was
              filled out by your client in the questionnaire or by you in the organizer.
            </div>
          )
        })
        .otherwise(() => (
          <div className="flex flex-col gap-2">
            To mark this checklist item as completed, either fill out the relevant information in
            the organizer or ask your client to fill it out in the questionnaire.
          </div>
        ))}
    </Dialog>
  )
}
